export default function getPricePerMeal(
  totalPrice: number | null | undefined,
  mealQuantity: number | null | undefined
): number {
  return Math.round((totalPrice || 0) / (mealQuantity || 1)) ?? 0
}
